module.exports = __webpack_public_path__ + "static/media/ips-payments.52b04318.svg";